import { SectionRenderer } from "@/components/sections/SectionRenderer";
import { getBootstrap } from "@/lib/bootstrap";
import { useCurrentPage } from "@/lib/sections";

const Page = () => {
  const page = useCurrentPage();
  const siteName = getBootstrap().site.name || "Site";

  if (!page) {
    return (
      <section className="container py-20 md:py-28">
        <p className="surtitre">{siteName}</p>
        <span className="separateur" />
        <h1 className="heading-hero mt-5">Page introuvable</h1>
      </section>
    );
  }

  if (!page.sections.length) {
    return (
      <section className="container py-20 md:py-28">
        <p className="surtitre">{siteName}</p>
        <span className="separateur" />
        <h1 className="heading-hero mt-5">{page.title}</h1>
        <p className="mt-6 text-base md:text-lg leading-relaxed text-foreground/80">
          Aucune section configurée. Ajoutez des sections dans l'admin WordPress.
        </p>
      </section>
    );
  }

  return <SectionRenderer sections={page.sections} />;
};

export default Page;
